import { useIntl } from 'react-intl-next';
export var useAIUsageDisclaimer = function useAIUsageDisclaimer(_ref) {
  var editorPluginAIProvider = _ref.editorPluginAIProvider;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var disclaimer;
  var aiUsageDisclaimer = editorPluginAIProvider.aiUsageDisclaimer;
  if (aiUsageDisclaimer) {
    disclaimer = {
      text: formatMessage(aiUsageDisclaimer.text),
      tooltip: formatMessage(aiUsageDisclaimer.tooltip),
      url: aiUsageDisclaimer.url
    };
  }
  return disclaimer;
};